<template>
  <div class="input-wrapper">
    <div class="input-icon-wrapper" @click="toggleCalendar">
      <input
        type="text"
        class="date-selection-input"
        placeholder="Choose a time window"
        :value="formattedDate"
      />
      <icon @click="toggleCalendar" class="input-icon">date_range</icon>
    </div>
    <SlideYUpTransition>
      <div v-if="showCalendar" class="calendar-holder" @click.stop="() => {}">
        <Calendar v-model="dateValue" />
      </div>
    </SlideYUpTransition>
  </div>
</template>

<script>
import Calendar from "@/components/datetimepicker/views/Calendar";
import { SlideYUpTransition } from "vue2-transitions";

export default {
  components: {
    Calendar,
    SlideYUpTransition,
  },
  props: {
    value: Array,
  },
  data() {
    return {
      showCalendar: false,
      months: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    };
  },
  computed: {
    dateValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    formattedDate() {
      if (this.value && this.value[0] && this.value[1]) {
        let startDate = new Date(this.value[0]);
        let endDate = new Date(this.value[1]);
        return `${startDate.getDate()}-${
          this.months[startDate.getMonth()]
        }-${startDate.getFullYear()} to ${endDate.getDate()}-${
          this.months[endDate.getMonth()]
        }-${endDate.getFullYear()}`;
      } else {
        return "";
      }
    },
  },
  watch: {
    value(value) {
      this.removeListener();
    },
    showCalendar(value) {
      if (value) {
        setTimeout(() => {
          document.addEventListener("click", this.removeListener);
        }, 200);
      }
    },
  },
  methods: {
    removeListener() {
      this.showCalendar = false;
      document.removeEventListener("click", this.removeListener, false);
    },
    toggleCalendar(event) {
      event.stopPropagation();
      this.showCalendar = !this.showCalendar;
    },
  },
};
</script>

<style lang="scss" scoped>
.input-wrapper {
  position: relative;
  margin-top: 10px;

  .input-icon-wrapper {
    position: relative;

    .date-selection-input {
      max-width: 500px;
      width: 100%;
      box-sizing: border-box;

      &:disabled {
        &:hover {
          border: 1px solid var(--color-accent);
          cursor: pointer;
        }
      }
    }

    .input-icon {
      position: absolute;
      right: 0;
      top: 10px;
      margin-right: 10px;

      &:hover {
        cursor: pointer;
        color: var(--color-primary);
      }
    }

    &:hover {
      .date-selection-input {
        border: 1px solid var(--color-accent);
      }
    }
  }

  .calendar-holder {
    position: absolute;
    top: 50px;
    right: -160px;
    background: var(--color-secondary);
    z-index: 99;
    border-radius: 5px;
    padding: 0 15px 10px 15px;
    border: 1px solid var(--border-color);
  }
}
</style>
